import {
  ActionReducerMap
} from '@ngrx/store';

import { reviewReducer, ReviewState } from '@ren/features/review/state/reducers/review.reducer';


export interface State {
  reviewState: ReviewState;
}

export const reducers: ActionReducerMap<State> = {
  reviewState: reviewReducer
};



